import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import joinTruck from "../../assets/joinTruck.png";

const JoinUs = () => {
  return (
    <div>
      <Box
        sx={{
          position: "relative",
          py: { xs: 10, md: 14 },
          textAlign: "center",
          color: "#fff",
          backgroundImage: `url(${joinTruck})`, // your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          overflow: "hidden",
        }}
      >
        {/* Dark Overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.85))",
          }}
        />

        <Container sx={{ position: "relative", zIndex: 2 }}>
          <Typography
            sx={{
              color: "#fcb900",
              fontWeight: 700,
              letterSpacing: 1,
              mb: 2,
            }}
          >
            WORK WITH US!
          </Typography>

          <Typography
            variant="h2"
            fontWeight={800}
            gutterBottom
            sx={{ fontSize: { xs: 30, md: 60 }, mb: 3, mx: "auto" }}
          >
            Build Your Skills. Shape the Future.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              opacity: 0.8,
              maxWidth: 600,
              mx: "auto",
              mb: 4,
            }}
          >
            Collaborate with a team focused on performance, accountability, and
            long-term value. Together, we transform vision into measurable
            results.
          </Typography>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "#fcb900",
              color: "#000",
              fontWeight: 700,
                letterSpacing: 1,
              px: 5,
              py: 1.5,
              "&:hover": {
                backgroundColor: "#e0a800",
                transform: "translateY(-3px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            Join Us!
          </Button>
        </Container>
      </Box>
    </div>
  );
};

export default JoinUs;
